import { managerExcelCellsForInn } from "./reportManagerFilterUtils";

export const SERIAL_REPORT_COLUMN_VISIBILITY_KEY =
  "serial_report_column_visibility";

export const SERIAL_METRIC_FIELDS = ["verify", "incident", "defect", "print"];

export const DEFAULT_SERIAL_COLUMN_VISIBILITY = {
  verify: true,
  incident: true,
  defect: true,
  print: true,
};

const METRIC_EXCEL_LABELS = {
  verify: "Верификация",
  incident: "Инциденты",
  defect: "Брак",
  print: "Напечатано",
};

export function readSerialColumnVisibility() {
  try {
    const raw = localStorage.getItem(SERIAL_REPORT_COLUMN_VISIBILITY_KEY);
    if (!raw) {
      return { ...DEFAULT_SERIAL_COLUMN_VISIBILITY };
    }
    const parsed = JSON.parse(raw);
    const next = { ...DEFAULT_SERIAL_COLUMN_VISIBILITY };
    for (const field of SERIAL_METRIC_FIELDS) {
      if (typeof parsed[field] === "boolean") {
        next[field] = parsed[field];
      }
    }
    return next;
  } catch {
    return { ...DEFAULT_SERIAL_COLUMN_VISIBILITY };
  }
}

export function saveSerialColumnVisibility(columnVisibility) {
  try {
    localStorage.setItem(
      SERIAL_REPORT_COLUMN_VISIBILITY_KEY,
      JSON.stringify(columnVisibility),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function serialisationGridTemplateStyle(columnVisibility) {
  const visibleCount = SERIAL_METRIC_FIELDS.filter(
    (f) => columnVisibility[f],
  ).length;
  const metricCols = visibleCount
    ? ` ${Array(visibleCount).fill("minmax(64px, 0.75fr)").join(" ")}`
    : "";
  return {
    gridTemplateColumns: `minmax(120px, 2fr) minmax(88px, 1fr) minmax(120px, 1.2fr) minmax(120px, 1.2fr)${metricCols}`,
  };
}

export function buildSerialisationExcelRows(list, columnVisibility, companys) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map((el) => {
    const row = {
      Компания: el.name_company,
      ИНН: el.inn,
      ...managerExcelCellsForInn(el.inn, companys),
    };
    for (const field of SERIAL_METRIC_FIELDS) {
      if (columnVisibility[field]) {
        row[METRIC_EXCEL_LABELS[field]] = el[field];
      }
    }
    return row;
  });
}
